import { AnyObject, GeometryMultiPolygon } from '@mri/types';
import { GeoType } from '@mri/enums';

export function polygonsToGeoJson(polygons: google.maps.Polygon[]): GeometryMultiPolygon {
  const coordinates: number[][][][] = [];

  polygons.forEach(polygon => {
    const paths = polygon.getPaths();

    paths.forEach((path: AnyObject) => {
      const pathCoordinates: number[][] = [];
      const firstPathCoordinates: number[] = [];
      path.forEach((latLng: google.maps.LatLng) => {
        if (firstPathCoordinates.length === 0) firstPathCoordinates.push(...[latLng.lng(), latLng.lat()]);

        pathCoordinates.push([latLng.lng(), latLng.lat()]);
      });
      pathCoordinates.push(firstPathCoordinates);
      coordinates.push([pathCoordinates]);
    });
  });

  return {
    type: GeoType.MULTI_POLYGON ,
    coordinates: coordinates as AnyObject
  };
}
